import {
  Box,
  TextContent,
  ColumnLayout,
  Input,
} from "@cloudscape-design/components-themed";
import { formatDate } from "../../utils/format";

interface ICompanyInfoRow {
  label: string;
  official?: string;
  application?: string;
  isDate?: boolean;
}

/**
 * 申請内容照会 現情報と申請情報を表示する
 */
export const CompanyInfoRow = (props: ICompanyInfoRow) => {
  const { label, official = "", application = "", isDate = false } = props;

  const officialValue = isDate ? formatDate(official) : official;
  const applicationValue = isDate ? formatDate(application) : application;

  return (
    <Box>
      <Box margin="s" float="left">
        <TextContent>
          <h5>{label}</h5>
        </TextContent>
      </Box>
      <ColumnLayout columns={2}>
        <Input value={officialValue} readOnly />
        <Input value={applicationValue} readOnly />
      </ColumnLayout>
    </Box>
  );
};
